import React, { memo, useEffect, useState } from 'react';
import { Select, Tabs } from 'antd';
import CommentList from './CommentList';
import { useComment } from './CommentProvider';
import { CommentActionType, CommentAnchorKey } from '../directUser/index';
import useCurrentModuleProp from './useCurrentModuleProp';
import { addScrollRecordToProvider } from '../directUser/utils';
import { COMMENT_LIST_TYPE } from './../utils';
// import { urlTabMap } from '@components/directUser/utils';

const { TabPane } = Tabs;
const { Option } = Select;

// const CurrentModule = 'Project Home';

const checkEmailsHas = (emails, email) => {
  if (!Array.isArray(emails)) {
    return false;
  }
  return emails.some((mentioned) => mentioned.email === email);
};

const CenterConsole = ({ isPanelActive }) => {
  // const curPosition = window.location.href;
  const {
    threadData,
    selfEmail,
    loading,
    setPanelVisible,
    commentScrollRecord,
  } = useComment();

  const Filters = {
    // ShowAll: () => true,
    open: (e) => e?.channelStatus === false,
    resolved: (e) => e?.channelStatus === true,
    mentioned: (e) =>
      checkEmailsHas(e.emails, selfEmail) ||
      (e.comments || []).some((comment) =>
        checkEmailsHas(comment.emails, selfEmail),
      ),
    all: (e) => true,
  };

  const [statusFilter, setStatusFilter] = useState('open');
  const [switchInput, setSwitchInput] = useState(false);
  const [activeTab, setActiveTab] = useState(1);
  const [targetChannelId, setTargetChannelId] = useState(null);

  const CurrentModuleProp = useCurrentModuleProp();

  useEffect(() => {
    if (CurrentModuleProp.moduleName) {
      setActiveTab(1);
    } else {
      setActiveTab(2);
    }
  }, [CurrentModuleProp]);

  const filter = (e) => {
    if (typeof CurrentModuleProp.filter !== 'function') {
      return (
        Filters[statusFilter](e) && e.module === CurrentModuleProp.moduleName
      );
    }
    return CurrentModuleProp.filter(e) && Filters[statusFilter](e);
  };

  const filterInAll = Filters[statusFilter];

  const totalThreads = threadData.filter(filterInAll).length;

  const totalModuleThreads = threadData.filter(filter).length;

  useEffect(() => {
    let anchorRecord = sessionStorage.getItem(CommentAnchorKey);
    if (anchorRecord && isPanelActive && !loading) {
      try {
        anchorRecord = JSON.parse(anchorRecord);

        if (
          anchorRecord &&
          anchorRecord.actionType === CommentActionType.OpenCommentCenter
        ) {
          setPanelVisible(true);
          setActiveTab(anchorRecord.channelStatus ? 2 : 1);
          setStatusFilter(anchorRecord.channelStatus ? 'resolved' : 'open');
          setSwitchInput((e) => !e);
          sessionStorage.removeItem(CommentAnchorKey);
          setTargetChannelId(anchorRecord.channel);
          addScrollRecordToProvider(
            commentScrollRecord,
            anchorRecord.channelStatus
              ? COMMENT_LIST_TYPE.ALL
              : COMMENT_LIST_TYPE.MODULE,
          );
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (!isPanelActive) {
      setTargetChannelId(null);
    }
  }, [isPanelActive, loading]);

  return (
    <div className="comment-center-console">
      <div className="console-header">
        <div className="console-title">Comments</div>
        <div className="comment-filter-select">
          <Select
            defaultValue="open"
            style={{ width: 100 }}
            onChange={(i) => {
              setStatusFilter(i);
              setSwitchInput((e) => !e);
            }}
            value={statusFilter}
            className="dd-select dd-select-sm"
            dropdownClassName="comment-filter-dropdown"
          >
            <Option value="all">All</Option>
            <Option value="open">Open</Option>
            <Option value="resolved">Resolved</Option>
            <Option value="mentioned">Mentioned</Option>
          </Select>
        </div>
      </div>
      <Tabs
        activeKey={String(activeTab)}
        onChange={(e) => setActiveTab(parseInt(e, 10))}
      >
        {CurrentModuleProp.moduleName ? (
          <TabPane
            className="module-comment-tab"
            tab={
              <div className="tab-wrapper">
                {CurrentModuleProp.moduleName}
                {totalModuleThreads > 0 ? (
                  <div className="total-unread">{totalModuleThreads}</div>
                ) : null}
              </div>
            }
            key="1"
          >
            <CommentList
              filter={filter}
              showModuleInTag={CurrentModuleProp.showModuleInTag}
              module={CurrentModuleProp.moduleName}
              sendIdentifier={CurrentModuleProp.identifier}
              switchInput={switchInput}
              shouldShowAddComment={!CurrentModuleProp.shouldHideAdd}
              isPanelActive={isPanelActive}
              targetChannelId={targetChannelId}
              commentListType={COMMENT_LIST_TYPE.MODULE}
            />
          </TabPane>
        ) : null}
        <TabPane
          className="all-comment-tab"
          tab={
            <div className="tab-wrapper">
              All Comments
              {totalThreads > 0 ? (
                <div className="total-unread">{totalThreads}</div>
              ) : null}
            </div>
          }
          key="2"
        >
          <CommentList
            showModuleInTag={true}
            module={CurrentModuleProp.moduleName}
            filter={filterInAll}
            shouldShowAddComment={false}
            switchInput={switchInput}
            isPanelActive={isPanelActive}
            targetChannelId={targetChannelId}
            commentListType={COMMENT_LIST_TYPE.ALL}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default memo(CenterConsole);
